import { Component } from '@angular/core';

interface SalesData {
  date: string;
  totalSales: string;
  totalOrders: number;
  avgOrderValue: string;
  paymentBreakdown: {
    cash: string;
    card: string;
    paypal: string;
    stripe: string;
  };
  fees: {
    transactionFees: string;
    orderFees: string;
    totalFees: string;
    netRevenue: string;
  };
}

@Component({
  selector: 'app-sales-data',
  standalone: false,
  templateUrl: './sales.component.html',
  styleUrl: './sales.component.scss',
})
export class SalesComponent {
  salesReport: SalesData[] = [];

  ngOnInit(): void {
    this.loadSalesReport();
  }

  loadSalesReport(): void {
    // Mock data (Replace with API call in the future)
    this.salesReport = [
      {
        date: '2025-03-10',
        totalSales: '£1,500.00',
        totalOrders: 45,
        avgOrderValue: '£33.33',
        paymentBreakdown: {
          cash: '£500.00',
          card: '£700.00',
          paypal: '£200.00',
          stripe: '£100.00',
        },
        fees: {
          transactionFees: '£50.00',
          orderFees: '£22.50',
          totalFees: '£72.50',
          netRevenue: '£1,427.50',
        },
      },
      {
        date: '2025-03-09',
        totalSales: '£1,200.00',
        totalOrders: 40,
        avgOrderValue: '£30.00',
        paymentBreakdown: {
          cash: '£400.00',
          card: '£600.00',
          paypal: '£150.00',
          stripe: '£50.00',
        },
        fees: {
          transactionFees: '£40.00',
          orderFees: '£20.00',
          totalFees: '£60.00',
          netRevenue: '£1,140.00',
        },
      },
    ];
  }
}
